import { useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Using useNavigate in React Router v6

const urlMappings = [
  {
    old_url:
      "/explore/article-details/326/7fb65400-35f1-4d9b-a8fa-d98abf2389f6",
    new_url: "/explore/what-exactly-is-the-menopause",
  },
  {
    old_url:
      "/explore/article-details/326/a8365f62-c76a-416e-a549-ea77dbdd08fa",
    new_url: "/explore/what-are-the-different-stages-of-menopause",
  },
  {
    old_url:
      "/explore/article-details/326/b80baca3-7c87-4775-bcc0-5fdc8a59d215",
    new_url: "/explore/early-and-premature-menopause-what-you-need-to-know",
  },
  {
    old_url:
      "/explore/article-details/326/2f273162-e830-4240-b5f6-0400251b0362",
    new_url: "/explore/what-do-i-need-to-know-about-perimenopause",
  },
  {
    old_url:
      "/explore/article-details/326/f75ac03b-d8e6-4f75-bb22-6eea9e6df0cf",
    new_url: "/explore/what-do-I-need-to-know-about-the-menopause",
  },
  {
    old_url:
      "/explore/article-details/326/4d1e8ca6-2fe7-4bec-853a-16425a016239",
    new_url: "/explore/postmenopause-what-does-life-after-menopause-look-like",
  },
  {
    old_url:
      "/explore/article-details/326/efcec00d-1342-4113-92fb-125ce5b5ace9",
    new_url:
      "/explore/from-hot-flushes-to-mood-swings-navigating-the-signs-of-menopause",
  },
  {
    old_url:
      "/explore/article-details/331/eaea9fbe-44d6-497a-b5e2-2e887a0df49d",
    new_url:
      "/explore/when-periods-start-changing-the-first-signs-of-menopause",
  },
  {
    old_url:
      "/explore/article-details/331/7e27bb51-35c9-4595-bda0-19616b2889bc",
    new_url: "/explore/dealing-with-stress-during-the-menopause",
  },
  {
    old_url:
      "/explore/article-details/331/03cd6420-3fa1-4b66-bb63-cee8f73bec92",
    new_url:
      "/explore/feeling-the-heat-understanding-hot-flushes-and-night-sweats-during-menopause",
  },
  {
    old_url:
      "/explore/article-details/331/7f7c5979-0ef9-4fa9-85f1-10a1cc338759",
    new_url:
      "/explore/understanding-the-physical-signs-associated-with-menopause-whats-happening-to-my-body",
  },
  {
    old_url:
      "/explore/article-details/331/64bff77f-da6d-41ad-8223-43f3a4c8b4d1",
    new_url:
      "/explore/how-does-menopause-affect-your-mood-and-mental-wellbeing",
  },
  {
    old_url:
      "/explore/article-details/331/e63389c4-9406-43d3-8c0e-3498f472403a",
    new_url: "/explore/sleep-disturbances-during-menopause",
  },
  {
    old_url:
      "/explore/article-details/331/21f17001-4fdc-4639-9640-88ab0abf7679",
    new_url:
      "/explore/the-intimate-details-of-genital-sexual-and-urinary-health-during-menopause",
  },
  {
    old_url:
      "/explore/article-details/336/a5a9be9c-e814-44ea-8ed7-580d3eb4b6bb",
    new_url: "/explore/managing-menopause-signs-what-treatments-are-available",
  },
  {
    old_url:
      "/explore/article-details/336/7bd8138a-c735-4cc9-ba56-2c7a92755aa6",
    new_url: "/explore/hormone-replacement-therapy-is-it-right-for-you",
  },
  {
    old_url:
      "/explore/article-details/336/a9f7d63a-4b23-4fe5-91f8-b33c9931e14a",
    new_url:
      "/explore/non-hormonal-and-alternative-options-to-manage-your-menopause-signs",
  },
  {
    old_url:
      "/explore/article-details/336/e364a3b9-6730-410f-9ea9-3c15f36107b8",
    new_url:
      "/explore/what-non-medicated-options-can-help-you-manage-your-menopause",
  },
  {
    old_url:
      "/explore/article-details/336/91982883-c716-4d7e-a02d-812104529e1c",
    new_url:
      "/explore/a-guide-to-having-menopause-conversations-with-your-doctor-or-pharmacist",
  },
  {
    old_url:
      "/explore/article-details/341/7723ed2b-0058-4b1f-b338-ad63c1512a10",
    new_url:
      "/explore/supporting-a-loved-one-through-menopause-a-guide-for-friends-and-family",
  },
  {
    old_url:
      "/explore/article-details/341/2686bde8-55ec-4dbd-9abc-6dc4ba6cb846",
    new_url:
      "/explore/navigating-menopause-at-work-tips-for-a-smoother-experience",
  },
  {
    old_url:
      "/explore/article-details/336/02f9186b-0ab3-4aca-abe0-41952b8a2ba2",
    new_url: "/explore/how-is-menopause-diagnosed",
  },
];
export const OldArticleRedirect = (props: any) => {
  const navigate = useNavigate(); // Use useNavigate for React Router v6
  const getLastSegment = (url: any) => {
    // Split the URL by '/' and get the last element
    const segments = url.split("/");
    return segments[segments.length - 1]; // Last segment
  };

  useEffect(() => {
    const currentUrl = window.location.pathname; // Get the current path
    // alert(currentUrl);
    // console.log("🚀 ~ useEffect ~ currentUrl:", currentUrl)
    // Check if the current URL contains "/explore/article-details"
    if (currentUrl.includes("/explore/article-details")) {
      console.log(getLastSegment(currentUrl));
      // Find the matching object in the array
      const mapping = urlMappings.find((item) =>
        currentUrl.includes(item.old_url),
      );

      if (mapping) {
        const finalUrl = getLastSegment(currentUrl);
        // Redirect to the new URL using navigate()
        navigate(mapping.new_url, {
          state: {
            articleId: getLastSegment(finalUrl),
            categoryId: 326,
          },
        }); // { replace: true } to avoid adding the redirect to history
      }
    }
  }, [navigate]);

  return <></>; // This component doesn't render anything, just handles the redirect logic
};
